import { Hero, HeroCol } from "../../components/Hero";
import { Customers } from "../../components/subcomponents/Customers";
import { InfoBox } from "../components/form/InfoBox";
import { useEffect, useState } from "react";
import { PoweringCaseStudiesList } from "./components/PoweringCaseStudiesList";
import TitleSection from "./components/TitleSection";

export const PoweringCaseStudies = ({ data }) => {
  const [attentionBox, setAttentionBox] = useState(false);

  useEffect(() => {
    if (window.location.state) {
      const isInfoboxPresent = window.location.state.infobox;
      if (isInfoboxPresent) setAttentionBox(true);
    }
  }, []);
  return (
    <>
      {attentionBox && <InfoBox closeModal={() => setAttentionBox(false)} type="Attention" />}
      <Hero background="violet-800" withStarsAnimation>
        <HeroCol>
          <TitleSection title={data.title} />
          <section className="poweringcasestudies-main">
            <PoweringCaseStudiesList
              poweringCaseStudies={data.poweringcasestudies}
              title={data.title}
              loading={false}
            />
          </section>
        </HeroCol>
        <Customers withMargin />
      </Hero>
    </>
  );
};
